var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "34CD84",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 0H1.667C.745 0 0 .745 0 1.667v16.666C0 19.255.745 20 1.667 20h16.666c.922 0 1.667-.745 1.667-1.667V1.667C20 .745 19.255 0 18.333 0zM15.6 7.005L8.635 14H8.63c-.088.088-.328.287-.604.287-.198 0-.422-.11-.61-.297L4.5 11.073a.208.208 0 010-.297l.927-.927a.206.206 0 01.146-.063c.052 0 .104.021.146.063l2.312 2.313 6.354-6.402a.206.206 0 01.146-.062c.057 0 .11.02.146.062l.912.943c.093.089.093.219.01.302z"
  })));
}
export default SvgCheckboxOn;